import { getCookie, getUrlParameter, SESSION_COOKIE_NAME } from "../EditorConstants";

export default class EditorAccessTokenHandler {

  public static getAccessToken(): string {
    //read session cookie
    const cookie = getCookie(SESSION_COOKIE_NAME) ? getCookie(SESSION_COOKIE_NAME).replace(/["\\]/g, ''): '';
    const accessToken = cookie ? cookie : getUrlParameter("accessToken");

    if (accessToken && accessToken.trim().length !== 0) {
      return accessToken;
    } else {
      throw new Error("User don't have valid session");
    }
  }
}
